import React from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import Sala from '../../model/ProcessoSala';
import PermissaoWrapper from '../../components/PermissaoWrapper';
import { PermissaoEnum } from '../../model/Usuario/Permissao';

interface SalaFormProps {
    items: Sala[];
    url: string;
    editId: string | null;
    setUrl: (url: string) => void;
    handleSubmit: (e: React.FormEvent) => void;
    handleEdit: (id: string) => void;
}

const SalaForm: React.FC<SalaFormProps> = ({ items, url, editId, setUrl, handleSubmit, handleEdit }) => {
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && editId !== null) {
            e.preventDefault();
            handleSubmit(e as unknown as React.FormEvent);
        }
    };

    return (
        <div className="container-form">
            {items.length === 0 ? (
                <Form onSubmit={handleSubmit}>
                    <Form.Group>
                        <Form.Label>URL</Form.Label>
                        <Form.Control type="text" value={url} onChange={e => setUrl(e.target.value)} required />
                    </Form.Group>
                    <Button variant="outline-primary" type="submit" className="btnAdicionar">
                        Criar Sala
                    </Button>
                </Form>
            ) : (
                <Table striped bordered hover className="my-3 table-striped">
                    <thead>
                        <tr>
                            <th>URL</th>
                            <PermissaoWrapper permissoesRequiridas={[(PermissaoEnum.ATUALIZAR_SALA_ESPERA),(PermissaoEnum.CADASTRAR_SALA_ESPERA)]}>
                                <th>Ações</th>
                            </PermissaoWrapper>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(item => (
                            <tr key={item.id}>
                                <td>
                                    {editId === item.id ? (
                                        <input
                                            type="text"
                                            value={url}
                                            onChange={e => setUrl(e.target.value)}
                                            onKeyDown={handleKeyPress}
                                        />
                                    ) : (
                                        <a href={item.salaUrl} target="_blank" rel="noopener noreferrer">
                                            {item.salaUrl}
                                        </a>
                                    )}
                                </td>
                                <PermissaoWrapper permissoesRequiridas={[(PermissaoEnum.ATUALIZAR_SALA_ESPERA), (PermissaoEnum.CADASTRAR_SALA_ESPERA)]}>
                                    <td>
                                        {editId === item.id ? (
                                            <Button variant="outline-success" onClick={handleSubmit}>
                                                Salvar
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => handleEdit(item.id)}
                                                className="btnEditar"
                                            >
                                                Editar
                                            </Button>
                                        )}
                                    </td>
                                </PermissaoWrapper>

                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default SalaForm;
